<template>
  <div class="producer-modify common-page">
    <!-- 面包屑 -->
    <a-breadcrumb>
      <a-breadcrumb-item>生产者管理</a-breadcrumb-item>
      <a-breadcrumb-item>修改</a-breadcrumb-item>
    </a-breadcrumb>

    <!-- 生产者信息 -->
    <section class="common-box">
      <div class="common-box-title">生产者信息</div>
      <div class="common-box-body">
        <a-form :form="form">
          <a-row>
            <a-col :span="8">
              <a-form-item label="是否允许生产" v-bind="formItemLayout">
                <a-radio-group
                  placeholder="请选择是否允许生产"
                  v-decorator="[ 
                    'enabled',
                    {
                      rules: [
                        { required: true, message: '请选择是否允许生产' }
                      ],
                    },
                  ]"
                >
                  <a-radio :value="true">是</a-radio>
                  <a-radio :value="false">否</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="姓名" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入生产者姓名"
                  maxlength="64"
                  v-decorator="[ 
                    'name',
                    {
                      rules: [
                        { required: true, message: '请输入生产者姓名', whitespace: true }
                      ],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="公司名称" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入公司名称"
                  maxlength="64"
                  v-decorator="[ 
                    'company',
                    {
                      rules: [],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="公司英文名称" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入公司英文名称"
                  maxlength="64"
                  v-decorator="[ 
                    'companyEn',
                    {
                      rules: [],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="手机号" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入手机号"
                  v-decorator="[
                    'phone',
                    {
                      rules: [
                        { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误' }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="地址" v-bind="formItemLayout">
                <a-input
                  placeholder="请输入地址"
                  maxlength="256"
                  v-decorator="[ 'address',
                    {
                      rules: [],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="描述" v-bind="formItemLayout">
                <a-textarea
                  :rows="4"
                  maxlength="256"
                  placeholder="请输入描述"
                  v-decorator="[ 'description',
                    {
                      rules: [],
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </section>

    <!-- 关联的产品table -->
    <section class="common-box">
      <div class="common-box-title">关联的产品</div>
      <div class="common-box-body">
        <a-table
          :columns="columns"
          :rowKey="(record, index) => index"
          :dataSource="data"
          :pagination="false"
        >
          <!-- 产品id -->
          <template slot="productid" slot-scope="text, record">
            <a-select
              v-if="record.isNew"
              :value="text"
              placeholder="产品ID"
              @change="e => handleChange(e, record.index, 'productid')"
              style="margin: -6px 0;width:100%"
            >
              <a-select-option
                v-for="product in products"
                :key="product.id"
                :value="product.id"
              >{{product.name}}</a-select-option>
            </a-select>
            <span v-else>{{getProductNameByID(text)}}</span>
          </template>

          <template slot="startnumber" slot-scope="text, record">
            <a-input-number
              v-if="record.editable"
              style="margin: -5px 0; width:100%;"
              :value="text"
              :min="0"
              :max="99999"
              @change="e => handleChange(e, record.index, 'startnumber')"
            />
            <template v-else>{{ text }}</template>
          </template>

          <template slot="activablenumber" slot-scope="text, record">
            <a-input-number
              v-if="record.editable"
              style="margin: -5px 0; width:100%;"
              :value="text"
              :min="0"
              @change="e => handleChange(e, record.index, 'activablenumber')"
            />
            <template v-else>{{ text }}</template>
          </template>

          <template slot="year" slot-scope="text, record">
            <a-input-number
              v-if="record.editable"
              style="margin: -5px 0; width:100%;"
              :value="text"
              :min="0"
              :max="99"
              @change="e => handleChange(e, record.index, 'year')"
            />
            <template v-else>{{ text }}</template>
          </template>

          <template slot="action" slot-scope="text, record">
            <template v-if="record.editable">
              <span v-if="record.isNew" class="cant-select">
                <a @click="saveRow(record,'add')">添加</a>
                <a-divider type="vertical" />
                <a-popconfirm title="是否要删除此行？" @confirm="remove(record.index)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
              <span v-else class="cant-select">
                <a @click="saveRow(record,'edit')">保存</a>
                <a-divider type="vertical" />
                <a @click="cancel(record.index)">取消</a>
              </span>
            </template>
            <span v-else class="cant-select">
              <a @click="toggle(record.index)">编辑</a>
              <!-- <a-divider type="vertical" />
              <a-popconfirm title="是否要删除此行？" @confirm="remove(record.index)">
                <a>删除</a>
              </a-popconfirm>-->
            </span>
          </template>
        </a-table>
        <a-button
          style="width: 100%; margin-top: 16px; margin-bottom: 8px"
          type="dashed"
          icon="plus"
          @click="newMember"
        >新增</a-button>
      </div>
    </section>

    <section class="submit-box">
      <a-button type="primary" @click="submit">提交</a-button>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import {
  editProducer,
  queryProducers,
  queryAllRelatedProducts,
  producerAddProduct,
  queryProduct,
  producerSetSerialNumSection
} from '../api/api'

const columns = [
  {
    title: '产品id',
    dataIndex: 'productid',
    scopedSlots: { customRender: 'productid' },
    width: '20%'
  },
  {
    title: '起始编号',
    dataIndex: 'startnumber',
    scopedSlots: { customRender: 'startnumber' },
    width: '20%'
  },

  {
    title: '可激活次数',
    dataIndex: 'activablenumber',
    scopedSlots: { customRender: 'activablenumber' },
    width: '20%'
  },
  {
    title: '串号年份',
    dataIndex: 'year',
    scopedSlots: { customRender: 'year' },
    width: '20%'
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: '20%'
  }
]

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 }
  }
}

export default {
  name: 'producer-modify',

  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout,
      columns,
      data: [], //table dataSource
      producers: [],
      relatedProducts: [],
      producer: {},
      products: []
    }
  },

  computed: {
    producerID() {
      return parseInt(this.$route.query.producerID)
    }
  },

  created() {
    this.fetchData()
    this.getSearchSelectData()
  },

  methods: {
    fetchData() {
      this.loading = true
      axios
        .all([queryProducers(), queryAllRelatedProducts()])
        .then(
          axios.spread((res1, res2) => {
            if (res1.error.code === 0) {
              this.producers = res1.response ? res1.response.producers : []
              this.producer = this.producers.find(
                producer => producer.id === this.producerID
              )
              this.initFormValue()
            }
            if (res2.error.code === 0) {
              this.relatedProducts = res2.response
                ? res2.response.relatedProducts
                : []
              this.data = this.relatedProducts.filter(
                relatedProduct =>
                  relatedProduct.produceruserid === this.producerID
              )
              this.data.forEach((item, index) => {
                this.$set(item, 'editable', false)
                this.$set(item, 'index', index + 1)
              })
            }
            this.loading = false
          })
        )
        .catch(err => {
          this.loading = false
        })
    },

    initFormValue() {
      this.form.setFieldsValue({
        enabled: this.producer.enabled,
        name: this.producer.name,
        company: this.producer.company,
        companyEn: this.producer.companyEn,
        phone: this.producer.phone,
        address: this.producer.address,
        description: this.producer.description
      })
    },

    submit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          let producer = {
            id: this.producer.id,
            name: values.name,
            companyName: values.company,
            companyName_en: values.companyEn,
            enabled: values.enabled,
            phone: values.phone,
            address: values.address,
            description: values.description
          }

          if (this.data.some(item => item.editable === true)) {
            this.$message.warning('请点击【添加】或【保存】')
          } else {
            editProducer(producer).then(res => {
              if (res.error.code === 0) {
                this.$message.success('修改成功')
              }
              this.loading = false
            })
          }
        }
      })
    },

    // 获取搜索下拉框数据
    getSearchSelectData() {
      queryProduct().then(res => {
        if (res.error.code === 0) {
          this.products = res.response.products
        }
      })
    },

    getProductNameByID(id) {
      let obj = this.products.find(item => item.id === id)
      return obj && obj.name
    },

    newMember() {
      const length = this.data.length
      this.data.push({
        index:
          length === 0
            ? '1'
            : (parseInt(this.data[length - 1].index) + 1).toString(),
        editable: true,
        isNew: true,
        productid: '',
        startnumber: '',
        activablenumber: '',
        year: ''
      })
    },

    remove(index) {
      const newData = this.data.filter(item => item.index !== index)
      this.data = newData
    },

    saveRow(record, type) {
      const { index, productid, startnumber, activablenumber, year } = record
      if (
        productid === '' ||
        startnumber === '' ||
        activablenumber === '' ||
        year === ''
      ) {
        this.$message.error('请填写完整信息')
        return
      }
      const target = this.data.find(item => item.index === index)

      if (type === 'add') {
        producerAddProduct({
          producerID: this.producerID,
          productID: target.productid,
          year: target.year,
          startNumber: target.startnumber,
          activableCount: target.activablenumber
        }).then(res => {
          if (res.error.code === 0) {
            this.$message.success('添加成功')
            target.editable = false
            target.isNew = false
            this.fetchData()
          }
        })
      } else if (type === 'edit') {
        producerSetSerialNumSection({
          id: target.id,
          year: target.year,
          startNumber: target.startnumber,
          activableCount: target.activablenumber
        }).then(res => {
          if (res.error.code === 0) {
            this.$message.success('保存成功')
            target.editable = false
            target.isNew = false
          }
        })
      }
    },

    toggle(index) {
      const target = this.data.find(item => item.index === index)
      target._originalData = { ...target }
      target.editable = !target.editable
    },

    cancel(index) {
      const target = this.data.find(item => item.index === index)
      Object.keys(target).forEach(key => {
        target[key] = target._originalData[key]
      })

      target._originalData = undefined
    },

    handleChange(value, index, column) {
      const newData = [...this.data]
      const target = newData.find(item => index === item.index)
      if (target) {
        target[column] = value
        this.data = newData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.producer-modify {
  margin-bottom: 56px;
}
</style>